module.exports = new __parcel__URL__("intercom--dark.ae2ca20e.svg").toString();